import { axiosInstanceMain } from "../../../utils/axiosGlobalUtils";
import { ITenant } from "../../AbmLocalPage/types";

export const getAllRubros = async (tenant: ITenant) =>
  await axiosInstanceMain.get(
    `/${tenant.path}/rubros?deviceId=0&clave=347ebc28653419c788302d8eba55b75a`
  );
export const handleNewRubro = async (
  idProducto: number,
  newIdRubro: number,
  tenant: ITenant
) =>
  await axiosInstanceMain.patch(
    `/admin/${tenant.path}/productos/${idProducto}/rubro`,
    {
      id: newIdRubro,
    }
  );

export const findRubro = async (
  idRubro: number | string,
  rubros: any,
  tenant: ITenant
) => {
  //console.log(idRubro);
  let allRubros: any = rubros || (await getAllRubros(tenant)).data;
  allRubros
    .map((r: any) => {
      return (r.rubros || []).map((j: any) => {
        if (j.rubros && j.rubros.length > 0) {
          j.rubros.map((k: any) => {
            if (k.rubros && k.rubros.length > 0) {
              return k;
            } else {
              return null;
            }
          });
        }
        return j;
      });
    })
    .flat();

  let rubroEncontrado: any;
  allRubros.forEach((r: any) => {
    if (r.rubros) {
      r.rubros.forEach((j: any) => {
        if (j.rubros) {
          j.rubros.forEach((k: any) => {
            if (k.idrubro === idRubro) {
              rubroEncontrado = k;
              return k;
            }
          });
        } else {
          if (j.idrubro === idRubro) {
            rubroEncontrado = j;
            return j;
          }
        }
      });
    } else {
      if (r.idrubro === idRubro) {
        rubroEncontrado = r;
        return r;
      }
    }
  });

  return rubroEncontrado;
};

export const findUnidadDeMedida = async (
  idUnidadDeMedida: number | string,
  idRubro: number | string,
  rubros: any,
  tenant: ITenant
) => {
  if (!rubros) return null;

  const rubro = await findRubro(idRubro, rubros, tenant);

  let unidadDeMedidaEncontrada = null;

  if (rubro?.unidadDeMedidaList?.length > 1) {
    unidadDeMedidaEncontrada = rubro.unidadDeMedidaList.find((u: any) => {
      return u.idUnidadDeMedida === idUnidadDeMedida;
    });
  } else {
    unidadDeMedidaEncontrada = rubro?.unidadDeMedidaList[0];
  }

  return unidadDeMedidaEncontrada;
};
